"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatZipCode = void 0;

var formatZipCode = function formatZipCode(zipcode) {
  if (!!zipcode) {
    if (/[a-zA-Z]/.test(zipcode)) {
      //Canada customer zip code format
      return zipcode.substring(0, 7);
    } else {
      zipcode = zipcode === null || zipcode === void 0 ? void 0 : zipcode.replace(/\s*/g, "");
      return zipcode.substring(0, 5);
    }
  } else {
    return zipcode;
  }
};

exports.formatZipCode = formatZipCode;